import { makeStyles } from '@material-ui/core';

export const selecionarEmpresaStyles = makeStyles({
  searchBarContainer: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
  },
  listItem: {
    fontWeight: 'bold',
  },
  searchBar: {
    border: '1px solid grey',
    marginRight: 16,
  },
  buttonCancel: { marginTop: '2rem' },
  buttonGerenciar: { textTransform: 'none'},
  paginationContainer: { marginTop: 'auto' },
  pagination: { display: 'flex', justifyContent: 'center', alignItems: 'center', flex: 'wrap' },
  select: { border: 0 },
});
